import { QUESTION_TYPE_CATALOG } from '@/features/instruments/question-builder/questionTypeCatalog'
import type { QuestionTypeId } from '@/features/instruments/question-builder/types'
import { formatTemplateQuestionType } from './formatTemplateQuestionType'

const API_TYPE_TO_BUILDER: Record<string, QuestionTypeId> = {
  multiple_choice: 'MULTIPLE_CHOICE',
  picture_choice: 'PICTURE_CHOICE',
  ranking: 'RANKING',
  yes_no: 'YES_NO',
  checkbox: 'CHECKBOX',
  dropdown: 'DROPDOWN',
  short_text: 'SHORT_TEXT',
  long_text: 'LONG_TEXT',
  date: 'DATE',
  rating: 'RATING',
  likert: 'LIKERT',
  slider: 'SLIDER',
  video: 'VIDEO',
}

/** Display label for template preview type pills (Figma 5086:8102 — matches question-type catalog titles). */
export function templateQuestionTypeLabel(apiType: string): string {
  const builderId = API_TYPE_TO_BUILDER[apiType]
  if (builderId) {
    const entry = QUESTION_TYPE_CATALOG.find((e) => e.id === builderId)
    if (entry) return entry.title
  }
  return formatTemplateQuestionType(apiType)
}

export function templateQuestionTypeIcon(apiType: string) {
  const builderId = API_TYPE_TO_BUILDER[apiType]
  if (!builderId) return null
  return QUESTION_TYPE_CATALOG.find((e) => e.id === builderId)?.Icon ?? null
}
